import { render, staticRenderFns } from "./userManagementAdmin.vue?vue&type=template&id=45d2d337&scoped=true"
import script from "./userManagementAdmin.vue?vue&type=script&lang=js"
export * from "./userManagementAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d2d337",
  null
  
)

export default component.exports